import { cn } from "../ui/cn";

type Props = {
	variant: 'filled' | 'outlined';
	hasValue: boolean;
	isFocus: boolean;
	error: boolean;
	labelBgColor?: string;
}

export const inputStyle = ({ variant, isFocus, error }: Omit<Props, 'hasValue' | 'labelBgColor'>) => {
	const shared = cn(
		'flex flex-row items-center h-14 w-full px-4 duration-200',
		'font-poppins text-body-large text-onSurface',
		'appearance-none border-none shadow-none outline-none resize-none overflow-hidden focus:outline-none focus:ring-0',
	);

	return variant === 'filled'
		? cn(
			shared,
			'pt-6 pb-1 rounded-t-[4px] bg-surfaceContainerHighest',
			'bg-bottom bg-origin-border bg-no-repeat',
			isFocus ? 'bg-[size:100%_3px,_100%_1px]' : 'bg-[size:0_3px,_100%_1px]',
			error // error60, primary60, neutralVariant20 - colors
				? 'bg-[linear-gradient(to_bottom,#eb4236ff,#eb4236ff),linear-gradient(to_bottom,#eb4236ff,#eb4236ff)]'
				: 'bg-[linear-gradient(to_bottom,#004060ff,#004060ff),linear-gradient(to_bottom,#2f3639ff,#2f3639ff)]',
		) : cn(
			shared,
			'pr-3 rounded-[4px] bg-transparent',
			isFocus
				? error ? 'shadow-[inset_0_0_0_3px_theme(colors.error60)]' : 'shadow-[inset_0_0_0_3px_theme(colors.primary60)]'
				: error ? 'shadow-[inset_0_0_0_1px_theme(colors.error60)]' : 'shadow-[inset_0_0_0_1px_theme(colors.primary60)]',
		);
}

export const labelStyle = ({ variant, isFocus, error, hasValue, labelBgColor }: Props) => {
	const shared = cn(
		'absolute z-10 origin-[0] left-4',
		'transition-all duration-300 pointer-events-none',
		'font-poppins text-body-large',
		error ? 'text-error60' : isFocus ? 'text-primary60' : 'text-neutralVariant20',
	);

	return variant === 'filled'
		? cn(
			shared,
			(isFocus || hasValue) ? 'scale-[74%]' : 'translate-y-1/2 scale-100',
		) : cn (
			shared, 'px-1',
			(isFocus || hasValue) ? (labelBgColor || 'bg-white') : 'bg-transparent',
			(isFocus || hasValue) ? '-translate-y-1/2 scale-[78%]' : 'translate-y-1/2 scale-100',
		);
}
